export const getStateName = (product) => {
    if(product.suscriptionCreated === false) {
        return ('data-lang-lbl-suscribe')
    }
    else if (!product.withTptKey && !product.withClientKey) {
        return ('data-lang-lbl-suscribed')
    }
    else if (product.withTptKey && !product.withClientKey) {
        return ('data-lang-lbl-payvalidated')
    }
    else if (product.withTptKey && product.withClientKey) {
        return ('data-lang-lbl-buyed')
    }
    else {
        return ""
    }
};